var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ExplainSearchBoxBase',[_c('SearchBox',{attrs:{"query":_vm.inputQuery,"size":"large","disabled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }